import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import logo from '../../logo.png';

const Navbar = () => {
  const location = useLocation();
  const { isAuthenticated, getUserName, logout } = useAuth();
  const { getCartItemCount } = useCart();

  const handleLogout = () => {
    logout();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const cartItemCount = getCartItemCount();

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img 
              src={logo} 
              alt="Bunny Boba Logo" 
              className="navbar-logo"
            />
          </Link>
        </div>
        
        <nav className="nav">
          <ul>
            <li>
              <Link 
                to="/" 
                className={isActive('/') ? 'active' : ''}
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/menu" 
                className={isActive('/menu') ? 'active' : ''}
              >
                Menu
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={isActive('/about') ? 'active' : ''}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={isActive('/contact') ? 'active' : ''}
              >
                Contact
              </Link>
            </li>
            
            {isAuthenticated ? (
              <>
                <li>
                  <Link 
                    to="/cart" 
                    className={`cart-link ${isActive('/cart') ? 'active' : ''}`}
                  >
                    🛒 {cartItemCount > 0 && <span className="cart-badge">{cartItemCount}</span>}
                  </Link>
                </li>
                <li className="user-dropdown">
                  <span className="user-name">Hello, {getUserName()}!</span>
                  <div className="dropdown-content">
                    <Link to="/profile">Profile</Link>
                    <Link to="/orders">My Orders</Link>
                    <button onClick={handleLogout} className="logout-btn">
                      Logout
                    </button>
                  </div>
                </li>
              </>
            ) : (
              <li>
                <Link 
                  to="/auth" 
                  className="login-btn"
                >
                  LOGIN
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
      

    </header>
  );
};

export default Navbar; 